import { render, staticRenderFns } from "./MessageTemplateSelect.vue?vue&type=template&id=7223d326&scoped=true"
import script from "./MessageTemplateSelect.vue?vue&type=script&lang=js"
export * from "./MessageTemplateSelect.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplateSelect.vue?vue&type=style&index=0&id=7223d326&prod&lang=scss"
import style1 from "./MessageTemplateSelect.vue?vue&type=style&index=1&id=7223d326&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7223d326",
  null
  
)

export default component.exports